import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'inline-flex',
      alignItems: 'center',
    },
    taxonomyContainer: {
      fontSize: theme.typography.pxToRem(10),
      lineHeight: theme.typography.pxToRem(16),
      textTransform: 'capitalize',
      display: 'flex',
      alignItems: 'center',
      color: COLORS.neutral.mediumGray,
    },
    taxonomy: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: theme.typography.fontWeightMedium,
      textDecoration: 'none',
    },
    link: {
      cursor: 'pointer',
      color: COLORS.primary.default,
    },
    icon: {
      fontSize: theme.typography.pxToRem(10),
      marginLeft: theme.spacing(0.5),
    },
    hint: {
      color: COLORS.primary.default,
      marginRight: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(12),
    },
    name: {
      maxWidth: 150,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
  }),
  { name: 'ButtonScoringMethod' }
);
